import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useQuestionSectionStyles = makeStyles(() => ({
    rootContainer: {
        display: "flex",
        flexDirection: "column",
        height: "100%", // Fit parent (flex: 1)
        [theme.breakpoints.down("md")]: {
            paddingBottom: "90px",
        },
        flex: 1,
        overflowX: "hidden",
    },
    headerContainer: {
        flex: "0 0 auto",
    },
    contentContainer: {
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1,
        touchAction: "pan-y",
        "@media (max-width:599px)": {
            maxHeight: "80vh !important",
        },
    },
    contentContainerMain: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    contentContainerMainFull: {
        flex: 1,
    },
    contentContainerMainHaf: {
        flex: 1,
    },


    questionTitle: {
        marginBottom: 0,
        fontWeight: "bold",
        color: theme.palette.text.primary,
    },
    questionText: {
        marginBottom: theme.spacing(3),
        lineHeight: 1.6,
        "& img": {
            maxWidth: "100% !important",
            height: "auto !important",
            display: "block",
            margin: "10px auto",
            "@media (min-width:600px)": {
                maxWidth: "80% !important", // Prevents massive images on tablets
            },
            "@media (max-width:599px)": {
                width: "100% !important",
            },
        },
    },
    buttonContainer: {
        flex: "0 0 auto",
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    questionNoWrapper: {
        borderBottom: "1px solid #ddd",
        // padding: "0px 10px",
        padding: "10px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    fullScreenBtn: {
        background: "#c9ddf5 !important",
        fontSize: "10px !important",
        fontWeight: "700 !important",
        color: "black !important",
        borderRadius: "0px !important",
    },
    options: {
        color: "#000000",
        fontFamily: "'Jost', sans-serif",
        fontSize: "1rem",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "normal",
        marginLeft: "2.5rem",
        [theme.breakpoints.down("sm")]: {
            marginLeft: "0.5rem",
        },
        "& input": {
            margin: "0.5rem 1rem",
        },
        "& img": {
            maxWidth: "100%",
            height: "auto",
            "@media (min-width:600px)": {
                maxWidth: "100% !important",
                maxHeight: "none !important",
            },
            "@media (max-width:599px)": {
                maxWidth: "85% !important",
                height: "auto !important",
            },
        },
        "& li": {
            margin: "1rem 0.5rem ",
            listStyle: "upper-latin",
            "& label": {
                display: "flex",
                alignItems: "flex-start",
                "& span": {
                    "& p": {
                        margin: "0",
                    },
                },
            },
        },
    },
    dflex: {
        display: "flex !important",
    },
    flexdirectioncolumn: {
        flexDirection: "column !important",
    },
    numberInput: {
        marginTop: "15px",
        marginLeft: "1rem",
        width: "15%",
        padding: "0.5rem",
        "@media (max-width:599px)": {
            width: "40%",
        },
    },
    questionsContainerinner: {
        // paddingLeft: "1rem",
        paddingLeft: "24px",
        paddingRight: "24px",
        paddingTop: "20px",
        paddingBottom: "20px",
        marginTop: "0px",
        "&::-webkit-scrollbar ": {
            display: "none",
        },
        "& img": {
            maxWidth: "100%",
            height: "auto",
            "@media (max-width:599px)": {
                maxWidth: "100%",
                width: "auto",
            },
        },

        "@media (max-width:599px)": {
            // paddingLeft: "0.5rem",
            // paddingRight: "0.5rem",
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "12px",
            paddingBottom: "12px",
        },
    },
    paragraphContainer: {
        color: "#000000",
        fontFamily: "'Jost', sans-serif !important",
        fontSize: "1rem",
        fontWeight: "500",
        lineHeight: 1.6,
        textAlign: "justify",
        "& *": {
            fontFamily: "'Jost', sans-serif !important",
        },
        "& p": {
            margin: "0.5rem 0",
            fontFamily: "'Jost', sans-serif !important",
            textAlign: "justify",
        },
        "& span": {
            fontFamily: "'Jost', sans-serif !important",
        },
        "& div": {
            fontFamily: "'Jost', sans-serif !important",
        },
        "& table, & td, & th": {
            fontFamily: "'Jost', sans-serif !important",
        },
    },
    questiontext: {
        color: "#000000",
        fontFamily: "'Jost', sans-serif !important",
        fontSize: "1rem",
        marginLeft: "2rem",
        marginTop: "1rem",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "normal",
        textAlign: "justify",
        "& *": {
            fontFamily: "'Jost', sans-serif !important",
        },
        "& p": {
            margin: "0rem 1rem",
            fontFamily: "'Jost', sans-serif !important",
            textAlign: "justify",
        },
        "& img": {
            maxWidth: "100% !important",
            height: "auto !important",
            "@media (min-width:600px)": {
                maxWidth: "70% !important",
            },
        },
        [theme.breakpoints.down("xs")]: {
            marginLeft: "0.5rem",
            "& img": {
                width: "100% !important",
            },
        },
    },
    upWrapper: {
        padding: "4px 8px 4px 0px",
        display: "flex",
        justifyContent: "end",
        borderTop: "1px solid #ddd",
    },
}));

export default useQuestionSectionStyles;
